<template>
    <ul class="breadcrumbs" :class="_class">
        <li>
            <img class="breadcrumbs__logo" :src="require('@/Assets/Images/logos/facilita-marketplace-icon-escuro.svg')" v-if="!iconWhite" alt="facilita" />
            <img class="breadcrumbs__logo" :src="require('@/Assets/Images/logos/facilita-marketplace-icon-branco.svg')" v-else alt="facilita" />
            <span>Você está em: </span>
        </li>

        <li >
            <router-link :to="{ name: 'Home' }">Encontre seu imóvel</router-link>
        </li>

        <template v-if="!noLink">
            <li v-for="(item, key) in breadcrumbs" :key="key">
                <router-link :to="{ name: item.url, params: { id: item.param } }">
                    <template v-if="item.title">{{ item.title }}</template>
                </router-link>
            </li>
        </template>

        <template v-else>
            <li v-for="(item, key) in breadcrumbs" :key="key">
                <template v-if="item.title">{{ item.title }}</template>
            </li>
        </template>
    </ul>
</template>

<script>
    export default {
        props: {
            breadcrumbs: {
                required: false,
                type: [Object, Array],
                default: function() {
                    return {}
                },
            },

            hideHome: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * Define se os links serão clicaveis
             */
            noLink: {
                type: Boolean,
                required: false,
                default: false
            },

            _class: {
                required: false,
                type: String,
                default: '',
            },

            iconWhite: {
                required: false,
                type: Boolean,
                default: false,
            },
        },

        computed: {
            path() {
                return this.$router.currentRoute
            },
        },

        watch: {
            nav: function(newValue, oldValue) {
                if (newValue === oldValue) return

                this.nav = newValue
            },
        },
    }
</script>

<style lang="stylus" scoped>
.breadcrumbs__logo
	max-height 35px
	width auto

</style>
